import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../Css/Custom.css";
import Logo from "../Images/CK-Logo-removebg-preview-removebg-preview.png";

function Navbar() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [services, setServices] = useState([]);

  // =========================
  // USER DATA FETCH
  // =========================
  const fetchUserData = async (userId) => {
    try {
      const response = await axios.get(
        `https://api.compliancekare.com/api/Compliance/GetUserDetail?UserId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      setUserData(response.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
      const userId = 29; // change dynamically if needed
      fetchUserData(userId);
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    setUserData(null);
  };

  // =========================
  // GET SERVICE TYPES API
  // =========================
  const getServiceTypes = async () => {
    try {
      const { data } = await axios.get(
        "https://api.compliancekare.com/api/Compliance/GetServiceTypes"
      );
      setServices(data.data || []);
      console.log("Service Types:", data);
    } catch (error) {
      console.error("Error fetching service types:", error);
      setServices([]);
    }
  };

  useEffect(() => {
    getServiceTypes();
  }, []);

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-light sticky-top"
      style={{ borderBottom: "1px solid #89c764" }}
    >
      <div className="container">
        <Link to="/">
          <img
            src={Logo}
            alt="logo"
            className="LogoImage"
            title="COMPLIANCEKARE"
          />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">

            {/* HOME */}
            <li className="nav-item">
              <Link to="/" className="nav-link">
                HOME
              </Link>
            </li>

            {/* DYNAMIC SERVICES */}
            {services?.map((service, index) => (
              <li className="nav-item dropdown" key={index}>
                <a
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  {service.serviceTypeName}
                </a>

                <ul className="dropdown-menu">
                  {service.serviceList?.map((item, i) => (
                    <li key={i}>
                      <Link
                        to={`/${service.serviceTypeName
                          .toLowerCase()
                          .replace(/\s+/g, "")}/${item.id}`}
                        className="dropdown-item"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            ))}

            {/* CONTACT */}
            <li className="nav-item">
              <Link to="/contact" className="nav-link">
                CONTACT US
              </Link>
            </li>

            {/* LOGIN / USER */}
            {isLoggedIn && userData ? (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  {userData?.data?.name}
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            ) : (
              <li className="nav-item">
                <Link to="/login" className="nav-link">
                  <button
                    type="button"
                    className="btn btn-outline-success"
                    style={{
                      border: "1px solid green",
                      color: "green",
                    }}
                  >
                    LOGIN
                  </button>
                </Link>
              </li>
            )}

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;